import api from "../../api.service"
import { getPaginatedResponse } from "../utils"

import queryString from "query-string"

/**
 * For query parameters, see:
 * https://docs.api.missionx.ai/operation/operation-get-planitems
 */
export function getPlanItems(queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/planItems?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * For query parameters, see:
 * https://docs.api.missionx.ai/operation/operation-get-planitems
 */
export function getMyRoles(queryParams = {}, signal) {
    const qs = queryString.stringify({
        withPersonLeftRole: true,
        ...queryParams,
    })

    return api
        .get(`/v2/planItems/roles/my?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * For query parameters, see:
 * https://docs.api.missionx.ai/operation/operation-get-planitems
 */
export function getPmPlanItems(queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)
    return api
        .get(`/v2/planItems/pm?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

export function getOrgPlanItems(orgId, queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/orgs/${orgId}/planItems?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

export function getPersonRaci(orgId, queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/orgs/${orgId}/planItems/person-raci?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

export function getOrgPlanItemsLite(orgId, queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/orgs/${orgId}/planItems/lite?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

export function getOrgPlanItemsBudgetLite(orgId, queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/orgs/${orgId}/planItems/budgetLite?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * For query parameters, see:
 * https://docs.api.missionx.ai/operation/operation-get-projects-parameter-planitems
 */
export function getMissionPlanItems(missionId, queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)
    return api
        .get(`/v2/missions/${missionId}/planItems?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * For query parameters, see:
 * https://docs.api.missionx.ai/operation/operation-get-projects-parameter-planitems
 */
export function getMissionPlanItemsLite(missionId, queryParams = {}) {
    const qs = queryString.stringify(queryParams)
    return api
        .get(`/v2/missions/${missionId}/planItems/lite?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}
